import React from "react";
import "./HairSalon.css";

const HairSalonHead = () => {
  return (
    <div className="hairSalonHeadContainer">
      <h2>HAIR SALON SERVICES IN BANGALORE</h2>
      <div className="hairSalonUnderline"></div>
    </div>
  );
};

export default HairSalonHead;
